import type { PropsWithChildren } from 'react';

import classNames from 'classnames';

import type { CoinType } from '../../stores/cointype/CoinTypeStore';
import { SocialCoin } from '../SocialCoin/SocialCoin';
import { SweepCoin } from '../SweepCoin/SweepCoin';

import classes from './CoinWithValue.module.scss';

export type CoinWithValue = PropsWithChildren<{
  coinType: CoinType;
  coinSide?: 'left' | 'right';
  coinWidth?: number | string;
  valueDataTestId?: string;
}>;

export function CoinWithValue({ coinType, children, coinSide = 'right', coinWidth, valueDataTestId }: CoinWithValue) {
  const CurrentCoinIcon = coinType === 'GC' ? SocialCoin : SweepCoin;

  return (
    <div className={classNames(classes.coinWithValue, coinSide === 'left' ? classes.left : classes.right)}>
      <div className={classes.value} data-testid={valueDataTestId}>
        {children}
      </div>
      <div className={classes.coin} style={{ width: coinWidth }}>
        <CurrentCoinIcon className={classes.coinImg} />
      </div>
    </div>
  );
}
